export enum LanguageActionTypes {
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  UPDATE_LANGUAGE = "UPDATE_LANGUAGE",
}
